import { Modal, Typography, Space, Button } from "antd";
import { useTheme } from "../../contexts/ThemeContext";

const { Paragraph } = Typography;

const LoginUpdateNoticeModal = ({ open, onClose }) => {
  const { theme } = useTheme();

  return (
    <>
      <Modal
        open={open}
        closable={false}
        maskClosable={false}
        keyboard={false}
        centered
        width={760}
        footer={null}
        styles={{
          content: {
            borderRadius: 20,
            overflow: "hidden",
            padding: 0,
            background: theme.cardBackground || "#ffffff",
          },
          body: {
            padding: 0,
          },
          mask: {
            backgroundColor: "rgba(6, 10, 30, 0.62)",
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <div
          style={{
            background: `linear-gradient(135deg, ${theme.primary}14 0%, ${theme.secondary}14 100%)`,
            borderBottom: `1px solid ${theme.border}`,
            // padding: "24px 24px 20px",
            display: "flex",
            justifyContent: "center",
            maxHeight: "60vh",
          }}
        >
          <img
            src="https://data4company.blob.core.windows.net/data4companyv2/LIVE 1106_SVG .svg"
            alt="GESTAO D4C"
            style={{
              maxWidth: "100%",
              width: "100%",
              objectFit: "fill",
              filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.08))",
              transition: "transform 0.35s ease",
            }}
          />
        </div>

        <div
          style={{
            padding: "24px",
          }}
        >
          <Paragraph
            style={{
              color: theme.textSecondary,
              fontSize: 16,
              lineHeight: 1.75,
              marginBottom: 20,
              textAlign: "justify",
            }}
          >
            <b>LIVE QUINTA-FEIRA: O relatório certo para fidelizar cada tipo de cliente de BPO</b>
            <br/>
            <br/>
            <b>PDF, dashboards prontos ou personalizados?</b> Nem todo cliente precisa do mesmo nível de informação e entregar a solução errada para o perfil errado pode reduzir a percepção de valor do seu serviço.
            <br/>
            <br/>
            Nesta live, vamos mostrar como identificar o perfil de cada cliente e definir o modelo de entrega mais adequado para aumentar a retenção da sua carteira. 
            <br/>
          </Paragraph>

          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <Button
              type="primary"
              block
              size="large"
              onClick={() => {
                window.open("https://bit.ly/4uW4OIR", "_blank");
              }}
              style={{
                height: 46,
                borderRadius: 12,
                fontWeight: 600,
                borderColor: theme.primary,
              }}
            >
              ADICIONE NA AGENDA PARA NÃO PERDER! 
            </Button>

            <Button
              type="default"
              block
              size="large"
              onClick={onClose}
              style={{
                height: 46,
                borderRadius: 12,
                fontWeight: 600,
                borderColor: theme.primary,
                boxShadow: "0 10px 24px rgba(0, 0, 0, 0.15)",
                transition: "all 0.25s ease",
              }}
            >
              Entendi, prosseguir
            </Button>
          </Space>
        </div>
      </Modal>
    </>
  );
};

export default LoginUpdateNoticeModal;
